var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBharatForge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 280,
    viewBox: "0 0 300 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.8996 228.7H64.0996L52.0996 211.9L47.9996 215.9V228.7H41.0996V191.7H47.9996V207.3L63.3996 191.7H72.7996L56.9996 207.1L72.8996 228.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.099 228.7H100.399L96.3988 218.1H83.3988L79.5988 228.7H72.2988L86.4988 191.7H92.9988L108.099 228.7ZM94.1988 212.2L89.6988 200.5L85.4988 212.2H94.1988Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.999 228.7H112.199V191.7H119.099V222.3H135.999V228.7Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.6 191.7L159 213.1V228.7H152.1V213.1L137.4 191.7H145.8L155.6 206.7L165.3 191.7H173.6Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.1 228.7H201.4L197.4 218.1H184.5L180.7 228.7H173.4L187.6 191.7H194.2L209.1 228.7ZM195.2 212.2L190.7 200.5L186.5 212.2H195.2Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.899 228.7H236.399L219.899 203.9V228.7H213.299V191.7H219.799L236.199 216.5V191.7H242.899V228.7Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M258.9 191.7H252V228.7H258.9V191.7Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88 126.421L181.381 159.263C181.381 159.263 150.661 180.62 118.175 162.543C118.175 162.543 96.4051 154.492 88 126.421Z",
    fill: "#204D8C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88 112.841L175.2 72.6406C175.2 72.6406 145.8 55.6406 113.4 76.0406C113.4 76.0406 91.4 90.4406 88 112.841Z",
    fill: "#204D8C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8918 122.082L197.167 149.72C202.931 142.262 206.526 133.012 206.961 122.879C207.682 106.073 199.534 90.942 186.669 82.0089L96.8918 122.082Z",
    fill: "url(#paint0_radial_111_71)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_111_71",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(173.5 114) rotate(6.71558) scale(100.649 129.893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "#86B4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#204D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7105,
    stopColor: "#204D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204D8C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBharatForge);
export default __webpack_public_path__ + "static/media/bharatForge.2b1d98bece35b6be582c1155ce1f3985.svg";
export { ForwardRef as ReactComponent };